eshopApp.controller('FeaturedProductsController', ['$scope', '$http', function($scope, $http) {

    $scope.spinner = true;
    $scope.products = null;
    $scope.dataLoaded = false;

    // Get products
    $scope.fetch = function() {
        $http.get('/m/products/featured/home').success(function(response) {
            $scope.products = response.data;
        }).finally(function() {
            $scope.dataLoaded = true;
            $scope.spinner = false;
        });
    };
    // Init
    $scope.fetch();

}]).directive('featuredCarousel', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {

            var isInitialized = false;

            // Observe products data
            scope.$watch('products', function(newVal, oldVal) {

                if (newVal !== null && !isInitialized) {

                    // Initialize carousel
                    $(element).owlCarousel({
                        navigation: true,
                        pagination: false,
                        autoPlay: true,
                        navigationText: [
                            '<i class="fa fa-chevron-left fa-2x"></i>',
                            '<i class="fa fa-chevron-right fa-2x"></i>'
                        ]
                    });

                    isInitialized = true;
                }
            });
        }
    };
});
